import React from 'react';
import PropTypes from 'prop-types';
import { STICKY_HEIGHT } from 'utils/Formatters';
import AccountPlayerUploads from './AccountPlayerUploads';
import AccountPlayerProfile from './AccountPlayerProfile';
import AccountPlayerPlays from './AccountPlayerPlays';
import AccountPlayerFreePlays from './AccountPlayerFreePlays';
import LineChart from '../dashboard/LineChart';
import BarChart from '../dashboard/BarChart';
import ASQSimpleSurveysContainer from '../../containers/asqs/ASQSimpleSurveysContainer';

export default class AccountPlayerChart extends React.Component {
  static propTypes = {
    accountPlayer: PropTypes.object.isRequired,
    anchor: PropTypes.string,
    data: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    onPlaysPageChange: PropTypes.func.isRequired,
    onFreePlaysPageChange: PropTypes.func.isRequired,
    onPlaysSortChange: PropTypes.func.isRequired,
    onFreePlaysSortChange: PropTypes.func.isRequired,
    onUpdateEngagement: PropTypes.func.isRequired,
    onUpdateInteractivity: PropTypes.func.isRequired,
  }

  componentDidUpdate(prevProps) {
    if (this.props.anchor && prevProps.anchor !== this.props.anchor) {
      window.scroll({
        top: document.getElementById(this.props.anchor).offsetTop - STICKY_HEIGHT,
      });
    }
  }

  onUpdateEngagement = (engagement) => {
    const { meta, data } = this.props;
    if (engagement === meta.periods.engagement) return;
    this.props.onUpdateEngagement(data.id, {engagement});
  }

  onUpdateInteractivity = (interactivity) => {
    const { meta, data } = this.props;
    if (interactivity === meta.periods.interactivity) return;
    this.props.onUpdateInteractivity(data.id, {interactivity});
  }

  onPlaysPageChange = (page) => {
    const { meta, data } = this.props;
    if (page === meta.plays.page) return;
    this.props.onPlaysPageChange(data.id, page);
  }

  onFreePlaysPageChange = (page) => {
    const { meta, data } = this.props;
    if (page === meta.freePlays.page) return;
    this.props.onFreePlaysPageChange(data.id, page);
  }

  render() {
    const { accountPlayer, data, meta, onPlaysSortChange, onFreePlaysSortChange } = this.props;
    return (
      <div>
        <LineChart data={data.engagement} chartType='account' title='Cards Played'
          meta={{value: meta.periods.engagement, onChange: this.onUpdateEngagement}} options={data.periods}/>
        <div className='row'>
          <div className="column">
            <ASQSimpleSurveysContainer />
          </div>
        </div>
        <BarChart data={data.interactivity} chartTypes={['liked', 'levels']}
          meta={{value: meta.periods.interactivity, onChange: this.onUpdateInteractivity}} options={data.periods} />
        <AccountPlayerProfile accountPlayer={accountPlayer} />
        <AccountPlayerPlays id={data.id} plays={data.plays} meta={meta.plays} onPageChange={this.onPlaysPageChange} onSortChange={onPlaysSortChange} />
        <AccountPlayerFreePlays id={data.id} freePlays={data.freePlays} meta={meta.freePlays} onPageChange={this.onFreePlaysPageChange} onSortChange={onFreePlaysSortChange} />
        <AccountPlayerUploads data={data.uploads} title='Photo Uploads' />
      </div>
    );
  }
}
